const internal = {
	key: 'internal',
	name: 'Internal Apps',
	components: {
		MuiCssBaseline: {
			styleOverrides: theme => ({
				body: {
					backgroundColor: theme.palette.background.eveCustom.secondary,
				},
			}),
		},
	},
	getDesignTokens: mode => ({
		mode,
		primary: {
			main: '#2A569D',
			light: '#F6F8FF',
			dark: '#002E6E',
			...(mode === 'dark' && {
				main: '#5993F0',
				dark: '#4C84D0',
				light: '#F6F8FF',
			}),
		},
		secondary: {
			main: '#0372D3',
			light: '#BADEFD',
			dark: '#025197',
			...(mode === 'dark' && {
				main: '#0383F2',
				dark: '#187EDC',
				light: '#BADEFD',
			}),
		},
		tertiary: {
			main: '#48B5B2',
			light: '#B2DDDF',
			dark: '#008583',
			...(mode === 'dark' && {
				main: '#48B5B2',
				dark: '#009997',
				light: '#B2DDDF',
			}),
		},
	}),
};

export default internal;
